import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { ChapterHead } from "./motion";
import { CHALLENGES } from "./data";

export const Challenges = () => (
  <section data-testid="chapter-challenges" className="chapter-print-break bg-alt py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <ChapterHead
        num="02"
        title="The Ten Challenges We Will Solve"
        sub="Drawn from Vision's own operations — four countries, eleven equipment lines, seven service streams — each mapped to the Odoo applications that close it."
      />
      <div className="grid gap-px overflow-hidden rounded-sm border border-line bg-line sm:grid-cols-2 lg:grid-cols-3">
        {CHALLENGES.map((c, i) => (
          <motion.div
            key={c.title}
            data-testid={`challenge-card-${i}`}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.55, delay: (i % 3) * 0.08, ease: [0.16, 1, 0.3, 1] }}
            className={`group relative bg-alt p-7 transition-colors duration-300 hover:bg-hover ${
              i === CHALLENGES.length - 1 ? "sm:col-span-2 lg:col-span-3" : ""
            }`}
          >
            <div className="flex items-baseline justify-between">
              <span className="outline-num font-display text-4xl font-extrabold">
                {String(i + 1).padStart(2, "0")}
              </span>
              <span className="font-mono2 text-[10px] tracking-[0.25em] text-accent uppercase">
                {c.area}
              </span>
            </div>
            <h3 className="font-display mt-5 text-base font-semibold leading-snug text-ink">{c.title}</h3>
            <p className="mt-4 flex items-center gap-2 text-sm text-ink4 transition-colors duration-300 group-hover:text-accent">
              <ArrowRight className="h-4 w-4 shrink-0 text-amber-500" />
              {c.solution}
            </p>
            <div className="absolute bottom-0 left-0 h-0.5 w-0 bg-amber-500 transition-[width] duration-500 group-hover:w-full" />
          </motion.div>
        ))}
      </div>
      <p className="mt-8 text-sm text-ink5">
        All ten challenges are addressed by one unified Odoo architecture — no point solutions, no
        bolt-on dashboards.
      </p>
    </div>
  </section>
);
